module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionBj.6c4d603f.png";